import React, { useState } from 'react';
import { ButtonsController } from 'src/components/selfService/features/OrderHistory/ZipDownload/buttons/ButtonsController';
import { useZipManagement } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/useZipManagement';
import { ZipFileStatus } from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { ModalsZipController } from './modals/ModalsZipController';

export interface DownloadZipControllerProps {
  isDisabled: boolean;
  corpId: string;
  dateFrom: Date;
  dateTo: Date;
  query: string;
  totalReceipts: number;
}

export function DownloadZipController({
  isDisabled,
  corpId,
  dateFrom,
  dateTo,
  query,
  totalReceipts,
}: DownloadZipControllerProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const onOpenHandle = () => setIsOpen(true);
  const onCloseHandle = () => setIsOpen(false);
  const isDateRangeSelected = !!dateTo && !!dateFrom;
  const {
    generateZipFile,
    status,
    maximumReceiptsAllowed,
    setStatus,
    filters,
    getZipFileFromS3,
  } = useZipManagement({
    corpId,
    query,
    dateTo,
    dateFrom,
    totalReceipts,
    onDownloadSuccess: onOpenHandle,
  });

  return (
    <>
      <ButtonsController
        isDisabled={isDisabled}
        status={status}
        onOpen={onOpenHandle}
        getZIPFileFromS3={onOpenHandle}
        isDateRangeSelected={isDateRangeSelected}
      />
      <ModalsZipController
        filters={filters}
        maximumReceiptsAllowed={maximumReceiptsAllowed}
        onClose={onCloseHandle}
        onStartGeneration={generateZipFile}
        isOpen={isOpen}
        status={status}
        onDownloadAgain={() => {
          setStatus(ZipFileStatus.FETCHING);
          getZipFileFromS3();
        }}
        totalReceipts={totalReceipts}
        onResetGeneration={() => {
          setStatus(ZipFileStatus.GENERATE);
          onCloseHandle();
        }}
      />
    </>
  );
}
